import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import type { RootState } from '../../../store/store';
import { resolveAuthenticatedPath } from '../userRoles';

export default function AuthenticatedRootGateway(): React.ReactElement {
  const user = useSelector((state: RootState) => state.auth.user);

  return <Navigate to={resolveAuthenticatedPath(user)} replace />;
}
